var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.01,
    viewBox: "0 0 24 24.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down-to-line",
    d: "M23,24H1a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Zm-8.23-5.14,6.35-6.75a2.923,2.923,0,0,0,.65-3.24,2.959,2.959,0,0,0-2.75-1.85H17V2.99a3,3,0,0,0-3.02-3H10a3,3,0,0,0-3,3v4H5.13A3.1,3.1,0,0,0,2.32,8.65a2.95,2.95,0,0,0,.54,3.4l6.29,6.8a3.983,3.983,0,0,0,5.62,0Z",
    transform: "translate(0 0.01)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.163911a48fed408038a0be4d1d2db61d.svg";
export { ForwardRef as ReactComponent };